$(function () {
  if ($(".landing-index").length < 1) return;

  $.fn.yurayura = function (config) {
    var obj = this;
    var i = 0;
    var defaults = {
      move: 8,
      duration: 700,
      delay: 0,
    };
    var setting = $.extend(defaults, config);
    return obj.each(function () {
      (function move() {
        i = i > 0 ? -1 : 1;
        var p = obj.position().top;
        $(obj)
          .delay(setting.delay)
          .animate(
            { top: p + i * setting.move },
            {
              duration: setting.duration,
              complete: move,
            }
          );
      })();
    });
  };
  $("#swipe").yurayura();

  var breakpoint = 850;

  $(".apps-carousel").slick({
    slidesToShow: 11,
    slidesToScroll: 5,
    prevArrow: '<a class="prev arrow">prev</button>',
    nextArrow: '<a class="next arrow">next</button>',
    infinite: true,
    autoplay: true,
    speed: 1500,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: breakpoint,
        settings: {
          slidesToShow: 6,
          slidesToScroll: 3,
          arrows: false,
          autoplay: true,
          speed: 1000,
          autoplaySpeed: 3000,
        },
      },
    ],
  });

  if (window.innerWidth < breakpoint) {
    $(".landing-see-more").on("click", function () {
      $(this).css("display", "none");
      $(this).next(".long-explanation").slideDown("fast");
    });

    $(".center").slick({
      centerMode: true,
      slidesToShow: 1,
      centerPadding: "40px",
      arrows: false,
      variableWidth: true,
      autoplay: true,
      speed: 1500,
      autoplaySpeed: 4000,
    });
  }
});
